import { REACT_APP_WEBHOOK_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { DOWNLOAD_URL, PRESIGNED_URL } from "./constants";
import {
  IDownloadPresignedUrlBody,
  IDownloadPresignedUrlResponse,
  IUploadFileOnPresignedUrlBody,
  IUploadPresignedUrlBody,
  IUploadPresignedUrlResponse,
} from "./model";
import axios, { AxiosResponse } from "axios";
const defaultProvide = async () => await getToken();

export const getUploadPresignedUrl = async (
  body: IUploadPresignedUrlBody
): Promise<string> => {
  const descriptor = new ApiServiceManager(
    `${REACT_APP_WEBHOOK_URL}${PRESIGNED_URL}`,
    "POST",
    defaultProvide
  );
  const response = (await fetchRequest(
    descriptor,
    body
  )) as IUploadPresignedUrlResponse;
  return response.presigned_url;
};

export const getDownloadPresignedUrl = async (
  body: IDownloadPresignedUrlBody
): Promise<string> => {
  const descriptor = new ApiServiceManager(
    `${REACT_APP_WEBHOOK_URL}${DOWNLOAD_URL}`,
    "POST",
    defaultProvide
  );
  const response = (await fetchRequest(
    descriptor,
    body
  )) as IDownloadPresignedUrlResponse;
  return response.presigned_url;
};

export const uploadFileOnPresignedUrl = async ({
  presignedUrl,
  file,
  progressCallback,
}: IUploadFileOnPresignedUrlBody): Promise<AxiosResponse> => {
  const response = await axios.put(presignedUrl, file, {
    headers: {
      "Content-Type": "",
    },
    onUploadProgress: progressCallback
      ? (progressEvent) => {
          progressCallback({
            loaded: progressEvent.loaded,
            total: progressEvent.total || 0,
          });
        }
      : undefined,
  });
  return response;
};
